/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../../../assets/scss/components/track/analyseView.scss";
import useAuth from "../../../hooks/useAuth";
import { StoreState } from "../../../types/models/store";
import { Actions, friendlyDateTime } from "../../../utils";
import TableCard, { CardData as TableCardData, headerItem } from "../../cards/TableCard";
import TrackLayout from "../../layout/track";
import { Pagination } from "../../pagination";

export const UploadView: React.FC = () => {
    const { user } = useAuth() as any;
    const { track_filter } = useSelector((state: StoreState) => state.auth);
    const navigate = useNavigate();
    const [keyword, setKeyword] = useState("");
    const [initFilter, setInitFilter] = useState<boolean>(true);
    const [pagination, setPagination] = useState<any>({
        page: 0,
        pages: 0,
        size: 10,
        total: 0
    });
    const [loading, setLoading] = useState(true);
    const [tableData, setTableData] = useState<any>([]);

    useEffect(() => {
        loadTableData();
    }, [user]);

    useEffect(() => {
        if (
            (track_filter.genre.length ||
                track_filter.mood.length ||
                track_filter.artist.length ||
                track_filter.composer.length ||
                track_filter.tempo.length) && !initFilter
        )
            navigate('/all-tracks');
        setInitFilter(false);
    }, [track_filter]);

    const loadTableData = (page: number = 0) => {
        if (user) {
            setLoading(false);
            if (user.uploads?.length) {
                const result: TableCardData[] = [];
                let list = user.uploads;
                if (keyword !== '') list = list.filter((t: any) => t.uploadname.indexOf(keyword) > -1);
                let _pagination = {
                    page: page,
                    size: pagination.size,
                    pages: Math.ceil(list.length / pagination.size),
                    total: list.length
                };
                for (var index, track, i = 0; i < _pagination.size; i++) {
                    index = i + _pagination.size * _pagination.page;
                    if (index >= _pagination.total) break;
                    track = list[index];
                    let metadata = track.metadata ? JSON.parse(track.metadata) : {};
                    let analyzedata = track.analyzedata ? JSON.parse(track.analyzedata) : {};
                    result.push({
                        id: track.id,
                        data: [
                            {
                                cell: (index + 1) + "",
                            },
                            {
                                title: track.uploadname,
                            },
                            {
                                cell: metadata.Duration,
                            },
                            {
                                cell: (analyzedata.data?.result ? "Analyzed on " : "Uploaded on ") + friendlyDateTime(track.updated_at),
                            },
                        ]
                    });
                }
                setPagination(_pagination);
                setTableData(result);
            }
        }
    };

    useEffect(() => {
        if (!loading) loadTableData();
    }, [keyword]);

    const handleKeyword = (e: any) => {
        setKeyword(e.target.value);
    }

    const handlePage = (p: number) => {
        setPagination({
            ...pagination,
            page: p
        });
        loadTableData(p);
    }


    return (
        <TrackLayout pageClass={"page-analyse-view mb-3"}>
            <div className="">
                <div className="uk-container-large">
                    <div className="search-component search-form">
                        <div className="container uk-container-large">
                            <div className="bg-white border border-white rounded d-flex justify-content-between align-items-center">
                                <input
                                    placeholder="Search uploaded songs"
                                    className="border border-white form-control search-track-input"
                                    onChange={handleKeyword}
                                    value={keyword}
                                />
                                <img
                                    src="/imgs/search.svg"
                                    className="me-2 py-2 focus"
                                    alt=""
                                />
                            </div>
                        </div>
                    </div>
                    <TableCard
                        title={""}
                        loading={loading}
                        filterable={false}
                        className={`member-table w-100`}
                        actions={[Actions.detail]}//Actions.edit, Actions.delete
                        data={tableData}
                        headers={[
                            headerItem("#", '20px'),
                            headerItem("Title"),
                            headerItem("Duration"),
                            headerItem("Status"),
                        ]}
                        onClickDetail={(id: any) => navigate(`/analyse-upload/${id}`)}
                    />
                    <Pagination
                        pagination={pagination}
                        handlePage={handlePage}
                        className={"mt-4"}
                    />
                </div>
            </div>
        </TrackLayout>
    );
};

export default UploadView;
